import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import OffersCarouselComponent, { type OffersCarouselIndexProps } from '@cx-modules/offers-carousel';

import { OffersClickoutGuard } from '~/modules/offers-clickout';

const isFE = typeof window !== 'undefined';

export const OffersCarousel = (propsIn: OffersCarouselIndexProps) => {
  const { i18n } = useTranslation();

  const props = isFE
    ? {
        ...propsIn,
        analyticsDataLayer: window.dataLayer,
        i18n,
      }
    : {
        ...propsIn,
        i18n,
      };

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureException(error);
        return null;
      }}
    >
      <OffersClickoutGuard componentName="OffersCarousel" values={props}>
        <OffersCarouselComponent {...props} />
      </OffersClickoutGuard>
    </ErrorBoundary>
  );
};

type OffersContentContractProps = {
  [key: string]: unknown;
  geoTargeting?: boolean | string;
  repub: string;
  subdivision?: string;
};

export const OffersCarouselContentContractForPageTemplate = ({
  geoTargeting,
  repub,
  subdivision,
  ...props
}: OffersContentContractProps) => {
  return {
    ...props,
    apiKey: ENV.OC_API_KEY[repub as keyof typeof ENV.OC_API_KEY],
    subdivisionCode: subdivision,
    theme: `oc${repub.toLowerCase()}`,
    repub,
    geoTargeting,
    ...(geoTargeting === false
      ? {
          countryCode: undefined,
          subdivisionCode: undefined,
        }
      : {}),
  };
};
